import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between align-center mb-3" }
const _hoisted_2 = { class: "guests-item__description" }
const _hoisted_3 = { class: "text-body-2" }

import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { computed } from 'vue'
import InputQuantity from '@/components/UI/Controls/Inputs/InputQuantity.vue'
import GuestsAgeRange from './GuestsAgeRange.vue'


export default {
  __name: 'GuestsCounter',
  props: {
  item: {
    type: Object,
    required: true
  },
  modelValue: {
    type: Object,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props) {

const { t } = useI18n()
const store = useStore()





const childrenAgeRange = computed(() => store.getters.childrenAgeRange)
const infantsAgeRange = computed(() => store.getters.infantsAgeRange)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.item.show)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(__props.item.title)), 1),
            (__props.item.id === 'children')
              ? (_openBlock(), _createBlock(GuestsAgeRange, {
                  key: 0,
                  "age-range": childrenAgeRange.value
                }, null, 8, ["age-range"]))
              : _createCommentVNode("", true),
            (__props.item.id === 'infants')
              ? (_openBlock(), _createBlock(GuestsAgeRange, {
                  key: 1,
                  "age-range": infantsAgeRange.value
                }, null, 8, ["age-range"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(InputQuantity, {
            min: __props.item.min,
            max: __props.item.max,
            default: __props.modelValue[__props.item.id],
            onChange: _cache[0] || (_cache[0] = $event => (
          _ctx.$emit('update:modelValue', { guestType: __props.item.id, quantity: $event })
        ))
          }, null, 8, ["min", "max", "default"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

}